import React from 'react';
import PropTypes from 'prop-types';
import css from '@src/js/Style';

export default class MenuSecondary extends React.Component {

    static get propTypes() {

        return {
            anchor: PropTypes.string,
            columns: PropTypes.any,
            services: PropTypes.any,
        };
    }

    render() {

        const { anchor } = this.props;

        return (
            <>
                <div className={ css('w-full text-primary title3 px-4 pt-4') }>{ anchor }</div>
                { this.renderColumns() }
                { this.renderServices() }
            </>
        );
    }

    renderColumns() {

        const { columns } = this.props;

        if (columns == undefined)
            return null;

        return (
            <div className={ css('w-full flex flex-wrap gap p-4 border-b-base') }>
                { columns.map((column, index) => this.renderColumn(column, index)) }
            </div>
        );

    }

    renderColumn(column, index) {

        return (
            <div className={ css('w-full flex flex-wrap gap') } key={ `column${index}` }>
                <div className={ css('text-bold') }>{ column.anchor }</div>
                { column.items.map((item, columnIndex) => this.renderColumnItem(item, columnIndex)) }
            </div>
        );
    }

    renderColumnItem(item, index) {

        return (
            <a className={ css('w-full text-dark') } href={ item.link } key={ `columnItem${index}` }>
                { item.anchor }
            </a>
        );
    }

    renderServices() {

        const { services } = this.props;
        
        if (services == undefined)
            return null;

        return (
            <div className={ css('w-full flex flex-wrap gap p-4') }>
                { services.map((service, index) => this.renderService(service, index)) }
            </div>
        );
    }

    renderService(service, index) {

        return (
            <a className={ css('flex items-center gap py-4 w-full') } href={ service.link } key={ `service${index}`}>
                <img className={ css('size-x-32 aspect-square') } alt={ service.anchor } src={ service.iconLink } />
                <div className={ css('text-bold text-dark hover:text-primary') }>{ service.anchor }</div>
            </a>
        );
    }

}